var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',{class:[_vm.color, _vm.className],staticStyle:{"border-radius":"3px"},attrs:{"size":_vm.size,"tile":""}},[_c('span',{class:['white--text', _vm.text_class]},[_vm._v(" "+_vm._s(_vm.clientInitials)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }